import { registerPlugin } from "@capacitor/core";
const Native = registerPlugin("Native", {
    web: () => import("./web").then((m) => new m.NativeWeb()),
});
export * from "./definitions";
export { Native };
//# sourceMappingURL=index.js.map